import React from "react";
import "./support.css";

const Support = () => {
  return (
    <>
      <div className="support-page">
        <h5>Protocols &amp; safety</h5>
        <h6>Vendor Acceptance: Setting the Standard</h6>
        <span>
          At ProtowCall, our acceptance protocol is unwavering – we exclusively
          welcome vendors of the highest caliber, committed to maintaining
          superior standards within our program.
        </span>
        <p>Just a Glimpse:</p>
        <span>
          The requirements listed below provide just a glimpse into the
          extensive criteria all vendors must meet within our app. These
          standards ensure that every vendor aligns with our commitment to
          excellence:
        </span>
        <li>Vulnerable Sector Checks:</li>
        <span>Pass and maintain up-to-date vulnerable sector checks.</span>
        <li>License and Insurance:</li>
        <span>Provide current insurance and tow license information.</span>
        <li>Safety Compliance:</li>
        <span>Furnish all applicable safety information.</span>
        <li>CVOR Information:</li>
        <span>- Submit current and valid CVOR information.</span>
        <li>Operational Agreement:</li>
        <span>
          -Agree to operate strictly under our defined terms and conditions.
        </span>
        <h5>Contact Us</h5>
        <span>George. Nicholas</span>
        <br />
        <span>George.Nicholas@protowcall.com</span>
        <br />
        <span>647-501-8444</span>
      </div>
    </>
  );
};

export default Support;
